/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontProfilesStatus = "DELETED" | "LIVE" | "REJECTED" | "UNDER_REVIEW" | "WORK_IN_PROGRESS" | "%future added value";
export type SbSharedStorefrontLink_browseContentModule = {
    readonly seller: {
        readonly sellerProfile: {
            readonly company: string | null;
        } | null;
        readonly sellerPreferences: {
            readonly urlLabel: string | null;
        } | null;
        readonly liveStorefrontProfile: {
            readonly status: StorefrontProfilesStatus | null;
        } | null;
    } | null;
    readonly " $refType": "SbSharedStorefrontLink_browseContentModule";
};
export type SbSharedStorefrontLink_browseContentModule$data = SbSharedStorefrontLink_browseContentModule;
export type SbSharedStorefrontLink_browseContentModule$key = {
    readonly " $data"?: SbSharedStorefrontLink_browseContentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedStorefrontLink_browseContentModule">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedStorefrontLink_browseContentModule",
  "type": "ContentModuleRegular",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": null,
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "sellerProfile",
          "storageKey": null,
          "args": null,
          "concreteType": "SellerProfile",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "company",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "sellerPreferences",
          "storageKey": null,
          "args": null,
          "concreteType": "SellerPreferences",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "urlLabel",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "liveStorefrontProfile",
          "storageKey": null,
          "args": null,
          "concreteType": "StorefrontProfile",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "status",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '33371f7c2872d7c508fd91f7f41a542e';
export default node;
